/**
 * taskLineHelpers.js
 *
 * Contains shared constants, regex definitions, and basic
 * validation utilities for task lines.
 */

/**
 * Character class for a single non-alphanumeric character.
 * Used for completion marks such as '-', 'x', '*', etc.
 */
const COMPLETION_MARK_CHARS = '[^\\p{Letter}\\p{Number}]';

/**
 * Regex that checks if a string consists of exactly one non-alphanumeric
 * character.
 */
export const REGEX_COMPLETION_MARK = new RegExp(
  `^${COMPLETION_MARK_CHARS}$`,
  'u'
);

/**
 * Regex that checks if the line starts with one non-alphanumeric
 * character followed by whitespace.
 */
export const REGEX_COMPLETION_MARK_FULL = new RegExp(
  `^(${COMPLETION_MARK_CHARS})\\s+`,
  'u'
);

/**
 * Allowed single-character priority values (digits and letters).
 */
export const PRIORITY_ALLOWED_CHARS = '0-9A-Za-z';

/**
 * Regex that matches a priority token in the format "!X",
 * where X is one allowed character.
 */
export const REGEX_PRIORITY = new RegExp(`!([${PRIORITY_ALLOWED_CHARS}])\\b`);

/**
 * Regex that matches tags of the form "#tag", with no spaces
 * inside the tag.
 */
export const REGEX_TAG = /#[^\s#]+/gu;

/**
 * Validates a single character as a priority (0-9 or A-Z or a-z).
 *
 * @param {string} value - The priority character to validate.
 * @returns {boolean} True if valid, false otherwise.
 */
export const validatePriority = (value) => {
  const priorityRegex = new RegExp(`^[${PRIORITY_ALLOWED_CHARS}]$`);
  if (typeof value !== 'string' || value.length !== 1) {
    return false;
  }
  return priorityRegex.test(value);
};
